var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPlace(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    clipRule: "evenodd",
    fillRule: "evenodd",
    height: 512,
    imageRendering: "optimizeQuality",
    shapeRendering: "geometricPrecision",
    textRendering: "geometricPrecision",
    viewBox: "0 0 512 512",
    width: 512,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_x0020_1"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m256 392.69c-2.04 0-3.94-1.04-5.04-2.75-5.81-9.03-14.14-21.06-23.78-34.98-44.13-63.74-110.81-160.06-110.81-215.23 0-77 62.64-139.64 139.63-139.64 77 0 139.64 62.64 139.64 139.64 0 55.17-66.69 151.49-110.82 215.22-9.64 13.93-17.97 25.96-23.77 34.99-1.11 1.71-3.01 2.75-5.05 2.75z",
    fill: "#ff5959"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m256 222.51c-42.69 0-77.43-34.73-77.43-77.43 0-42.69 34.74-77.43 77.43-77.43 42.7 0 77.43 34.74 77.43 77.43 0 42.7-34.73 77.43-77.43 77.43z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("g", {
    fill: "#b3b3b3"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m256.14 464.34c-2.54 0-5.08-.04-7.64-.13-29.33-1.07-56.23-8.21-75.74-20.11-19.63-11.96-29.92-27.68-28.98-44.25 1.04-18.22 15.2-34.54 39.88-45.97 3-1.39 6.57-.08 7.96 2.93 1.39 3 .08 6.57-2.92 7.96-20.17 9.34-32.18 22.37-32.94 35.76-.68 11.94 7.58 23.78 23.24 33.33 37 22.55 101.73 24.86 144.31 5.15 20.16-9.34 32.17-22.38 32.93-35.77.68-11.94-7.57-23.77-23.24-33.32-2.83-1.73-3.73-5.42-2-8.25 1.72-2.83 5.41-3.72 8.24-2 19.63 11.97 29.92 27.68 28.98 44.25-1.04 18.22-15.2 34.55-39.88 45.97-20.29 9.4-45.69 14.45-72.2 14.45z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m256.23 511.91c-4.02 0-8.05-.08-12.09-.22-46.33-1.69-88.75-12.93-119.46-31.65-30.22-18.42-46.07-42.4-44.64-67.52 1.58-27.77 23.5-52.8 61.72-70.5 3-1.39 6.57-.08 7.96 2.93 1.39 3 .08 6.57-2.92 7.96-33.52 15.51-53.49 37.49-54.78 60.29-1.17 20.49 12.65 40.59 38.91 56.6 60.09 36.63 165.19 40.41 234.28 8.43 33.51-15.52 53.48-37.49 54.78-60.29 1.17-20.49-12.65-40.59-38.91-56.6-2.83-1.73-3.73-5.42-2-8.24 1.72-2.83 5.41-3.73 8.24-2 30.22 18.42 46.08 42.4 44.64 67.52-1.58 27.76-23.5 52.8-61.71 70.49-32.02 14.83-72.11 22.8-114.02 22.8z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlace);
export default __webpack_public_path__ + "static/media/place.f624856cedf7bb4c5a5302b024017398.svg";
export { ForwardRef as ReactComponent };